import { queryAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import { domainToRegex } from "../urlPatternConversion";
import logo from "./logo.svg";

export const prtg = defineConnector({
  identifier: "prtg",
  name: "PRTG",
  tagLine: "Network monitoring and management",
  logo,
  protocol: "http",
  tags: ["it", "observability"],
  defaultUrlPattern: ({ domain }) => domainToRegex(domain),
  auth: (app) => queryAuth([{ name: "apitoken", value: app.secret.apiToken }]),
  steps: [
    {
      title: "Get an API token",
      items: [
        {
          kind: "markdown",
          content:
            "In PRTG, go to **Setup → Account Settings → API Keys** and create a new API token.",
        },
      ],
    },
    {
      title: "Enter your credentials",
      items: [
        {
          kind: "baseUrl",
          label: "PRTG server URL",
          required: true,
          placeholder: "https://prtg.example.com",
          target: { kind: "configuration", field: "domain" },
          helperText:
            "The URL of your PRTG server, including any path it’s served under.",
        },
        {
          kind: "input",
          label: "API token",
          required: true,
          target: { kind: "secrets", field: "apiToken" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ domain }) => `${domain}/api/status.json`,
  },
});
